let $document;

let React;

$document = require("../helpers/helpers").default.document;

React = require("react");

class FeatureSpace extends React.Component {
    componentWillMount() {
        return this.setState({
            content: (
                <div className="container row">
                    <div className="info">
                        <h3>Noun Project for Mac</h3>
                        <p>
                            Search, drag, and drop icons
                            <br /> right from your desktop.
                        </p>
                        <a
                            href="/for-mac/"
                            className="ui_eye call-to-action button button-icon"
                            title="Learn more"
                        >
                            Learn more
                        </a>
                    </div>
                    <div className="image-container">
                        <div className="product-image" />
                    </div>
                </div>
            )
        });
    }
    render() {
        return (
            <section className="feature-space blue">
                {this.state.content}
            </section>
        );
    }
}

class Footer extends React.Component {
    componentWillMount() {
        return this.setState({
            showFeature: false
        });
    }

    componentDidMount() {
        return window.addEventListener("resize", this.handleResize.bind(this));
    }

    componentWillUnmount() {
        return window.removeEventListener(
            "resize",
            this.handleResize.bind(this)
        );
    }

    constructor(props) {
        super(props);

        this.state = {
            emailClass: "hidden",
            emailInputClass: "",
            emailText: "",
            windowWidth: $(window).width()
        };
    }

    handleResize() {
        return this.setState({
            windowWidth: $(window).width()
        });
    }

    onEmailSubmit(e) {
        e.preventDefault();
        return $.post(e.target.action, $(e.target).serialize()).done(
            (_this => data => {
                if (data.success) {
                    _this.setState({
                        emailClass: "ui_heart email-added",
                        emailInputClass: "hidden",
                        emailText: gettext(
                            "Thanks for joining the mailing list!"
                        )
                    });
                }
                if (data.alreadySubscribed) {
                    return _this.setState({
                        emailClass: "ui_heart email-added",
                        emailInputClass: "hidden",
                        emailText: gettext("You're already subscribed!")
                    });
                }
            })(this)
        );
    }

    render() {
        if (this.state.showFeature) {
            this.featureSpace = React.createElement(FeatureSpace, null);
        } else {
            this.featureSpace = React.createElement("div", null);
        }
        if (this.state.windowWidth >= 960) {
            this.slogan = void 0;
            this.links = (
                <div className="links">
                    <ul className="project">
                        <li className="link-title">The Project</li>
                        <li>
                            <a href="/about/" title="About">
                                About
                            </a>
                        </li>
                        <li>
                            <a
                                href="http://blog.thenounproject.com/"
                                title="Blog"
                                target="_blank"
                            >
                                Blog
                            </a>
                        </li>
                        <li>
                            <a href="/press/" title="Press Kit" target="_blank">
                                Press Kit
                            </a>
                        </li>
                        <li>
                            <a href="/jobs/" title="Jobs">
                                Jobs
                            </a>
                        </li>
                        <li>
                            <a href="/iconathon/" title="Iconathon">
                                Iconathon
                            </a>
                        </li>
                        <li>
                            <a
                                href="http://www.draft.la/"
                                title="Draft.LA"
                                target="_blank"
                            >
                                Draft.LA
                            </a>
                        </li>
                    </ul>
                    <ul className="learn-more">
                        <li className="link-title">Learn More</li>
                        <li>
                            <a href="/accounts/pricing/" title="Pricing">
                                Pricing
                            </a>
                        </li>
                        <li>
                            <a href="/for-mac/" title="Noun Project for Mac">
                                for Mac
                            </a>
                        </li>
                        <li>
                            <a
                                href="/nounji/"
                                title="Nounji on the new app store for iMessage"
                            >
                                Nounji
                            </a>
                        </li>
                        <li>
                            <a href="/team/" title="Teams">
                                Teams
                            </a>
                        </li>
                        <li>
                            <a href="/creators/" title="Creators">
                                Creators
                            </a>
                        </li>
                        <li>
                            <a href="/developers/" title="API">
                                API
                            </a>
                        </li>
                    </ul>
                    <ul className="support">
                        <li className="link-title">Support</li>
                        <li>
                            <a
                                href="mailto:info@thenounproject.com?subject=Wanted to get in contact"
                                title="Contact"
                            >
                                Contact
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://thenounproject.zendesk.com/"
                                title="FAQ"
                            >
                                FAQ
                            </a>
                        </li>
                        <li>
                            <a href="/handbook/" title="Creator's Handbook">
                                Creators Handbook
                            </a>
                        </li>
                        <li>
                            <a href="/legal/terms-of-use/" title="Terms of Use">
                                Terms of Use
                            </a>
                        </li>
                        <li>
                            <a
                                href="/legal/privacy-policy/"
                                title="Privacy Policy"
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li>
                            <a
                                href="/legal/creator-terms/"
                                title="Creator Terms"
                            >
                                Creator Terms
                            </a>
                        </li>
                    </ul>
                </div>
            );
            this.copyRight = void 0;
        } else {
            this.slogan = (
                <p>
                    {gettext(
                        "Creating, Sharing and Celebrating the World’s Visual Language."
                    )}
                </p>
            );
            this.links = void 0;
            this.copyRight = (
                <p className="copyright">
                    Noun Project {new Date().getFullYear()}
                </p>
            );
        }
        this.footerContent = (
            <div className="footer-navigation container row">
                <div className="outreach">
                    <header>
                        <h1 className="organization-name ui_logo">
                            Noun Project
                        </h1>
                        {this.slogan}
                    </header>
                    <form
                        id="email-updates"
                        className="email-signup mailer"
                        action="/mailing-list/subscribe/"
                        name="mc-embedded-subscribe-form"
                        method="post"
                        noValidate=""
                        onSubmit={this.onEmailSubmit.bind(this)}
                    >
                        <input
                            id="EMAIL"
                            name="email"
                            type="email"
                            placeholder="Enter email to receive updates and newsletter"
                            className={this.state.emailInputClass}
                        />
                        <label
                            htmlFor="EMAIL"
                            className={this.state.emailClass + " email-added"}
                        >
                            {this.state.emailText}
                        </label>
                    </form>
                    <div className="social">
                        {gettext("Connect with us ")}
                        <ul>
                            <li>
                                <a
                                    href="https://twitter.com/nounproject"
                                    className="ui_twitter"
                                    title="Noun Project Twitter"
                                    target="_blank"
                                >
                                    <span>Noun Project Twitter</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.facebook.com/thenounproject"
                                    className="ui_facebook"
                                    title="Noun Project Facebook"
                                    target="_blank"
                                >
                                    <span>Noun Project Facebook</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://instagram.com/nounproject/"
                                    className="ui_instagram"
                                    title="Noun Project Instagram"
                                    target="_blank"
                                >
                                    <span>Noun Project Instagram</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://dribbble.com/nounproject"
                                    className="ui_dribbble"
                                    title="Noun Project Dribble"
                                    target="_blank"
                                >
                                    <span>Noun Project Dribble</span>
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.behance.net/noun_project"
                                    className="ui_behance"
                                    title="Noun Project Behance"
                                    target="_blank"
                                >
                                    <span>Noun Project Behance</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                {this.links}
                {this.copyRight}
            </div>
        );
        return (
            <section className="footer vcard" id="footer">
                {this.featureSpace}
                {this.footerContent}
            </section>
        );
    }
}

export default Footer;
